module.exports = __webpack_public_path__ + "img/CM-MC-26-CJDR-Established.06e3bde7.jpg";